var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_124_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8215 0.178474C25.7411 0.0980578 25.6398 0.0417506 25.529 0.0159226C25.4183 -0.00990548 25.3025 -0.0042236 25.1948 0.0323254L0.413545 8.44084C0.297322 8.48026 0.195711 8.55386 0.122017 8.65199C0.0483241 8.75013 0.00598326 8.86824 0.00053899 8.99084C-0.00490528 9.11345 0.0268008 9.23484 0.0915056 9.33913C0.15621 9.44341 0.250898 9.52572 0.36317 9.57529L11.5042 14.4958L16.4247 25.6368C16.4743 25.7491 16.5566 25.8437 16.6609 25.9084C16.7652 25.9731 16.8866 26.0048 17.0092 25.9994C17.1318 25.9939 17.2499 25.9516 17.3481 25.8779C17.4462 25.8042 17.5198 25.7026 17.5592 25.5864L25.9677 0.805115C26.0043 0.697421 26.0099 0.581657 25.9841 0.470916C25.9582 0.360175 25.9019 0.258875 25.8215 0.178474ZM2.28631 9.09236L23.1123 2.0259L11.8305 13.3076L2.28631 9.09236ZM16.9076 23.7137L12.6923 14.1694L23.974 2.88776L16.9076 23.7137Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_124_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSent);
export default __webpack_public_path__ + "static/media/sent.70e2ed3ca5c046189f33c02808f4cfcf.svg";
export { ForwardRef as ReactComponent };